import { all } from 'redux-saga/effects';
import candidateSaga from '../containers/CandidatesPane/sagas';
import surveySaga from '../containers/SurveysPane/sagas';
import positionsSaga from '../containers/PositionsPane/sagas';
import prospectsSaga from '../containers/ProspectsPane/sagas';

export default function* dashboardSaga() {
  yield all([
    candidateSaga(),
    positionsSaga(),
    prospectsSaga(),
    surveySaga()
  ]);
}
